var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "49px",
    viewBox: "0 0 50 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BE2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.3533333,31.6666667 C16.734321,31.6666667 17.9914259,31.4547222 19.1246481,31.0308333 C20.2578704,30.6069444 21.2265926,30.0158333 22.0308148,29.2575 C22.835037,28.4991667 23.4585123,27.6008333 23.9012407,26.5625 C24.3439691,25.5241667 24.5653333,24.3905556 24.5653333,23.1616667 C24.5653333,21.9405556 24.3439691,20.8108333 23.9012407,19.7725 C23.4585123,18.7341667 22.835037,17.8377778 22.0308148,17.0833333 C21.2265926,16.3288889 20.2578704,15.7377778 19.1246481,15.31 C17.9914259,14.8822222 16.734321,14.6683333 15.3533333,14.6683333 L15.3533333,14.6683333 L8.45651852,14.6683333 L8.45651852,31.6666667 L15.3533333,31.6666667 Z M15.3533333,28.6333333 L12.5994815,28.6333333 L12.5994815,17.7016667 L15.3533333,17.7016667 C16.1413086,17.7016667 16.8439877,17.8280556 17.4613704,18.0808333 C18.0787531,18.3336111 18.6006852,18.6952778 19.0271667,19.1658333 C19.4536481,19.6363889 19.7806173,20.21 20.0080741,20.8866667 C20.2355309,21.5633333 20.3492593,22.3216667 20.3492593,23.1616667 C20.3492593,24.0094444 20.2355309,24.7716667 20.0080741,25.4483333 C19.7806173,26.125 19.4536481,26.6986111 19.0271667,27.1691667 C18.6006852,27.6397222 18.0787531,28.0013889 17.4613704,28.2541667 C16.8439877,28.5069444 16.1413086,28.6333333 15.3533333,28.6333333 L15.3533333,28.6333333 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-37.2%",
    y: "-35.3%",
    width: "174.5%",
    height: "170.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.482352941   0 0 0 0 0.88627451  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Notification_Universities-",
    transform: "translate(-925.000000, -970.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(895.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(30.000000, 904.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Direct-apply-Copy"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 23.5,
    cy: 22.5,
    rx: 23.5,
    ry: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9652222,14.6683333 L38.8376667,31.6666667 L35.6451481,31.6666667 L35.4721862,31.6600231 C35.1935065,31.6378781 34.9627778,31.5603704 34.78,31.4275 C34.5606667,31.2680556 34.3941358,31.0638889 34.2804074,30.815 L34.2804074,30.815 L33.2324815,27.8516667 L26.4818889,27.8516667 L25.433963,30.815 L25.3718185,30.9431 C25.2775864,31.1104778 25.137863,31.2641667 24.9526481,31.4041667 C24.7211296,31.5791667 24.4347778,31.6666667 24.0935926,31.6666667 L24.0935926,31.6666667 L20.8767037,31.6666667 L27.7491481,14.6683333 L31.9652222,14.6683333 Z M29.845,18.1683333 C29.7231481,18.6427778 29.5931728,19.0822222 29.4550741,19.4866667 C29.3169753,19.8911111 29.187,20.2411111 29.0651481,20.5366667 L29.0651481,20.5366667 L27.4323333,25.1683333 L32.2942222,25.1683333 L30.6492222,20.5133333 L30.5563102,20.2818229 C30.461875,20.0404688 30.3628704,19.7695833 30.2592963,19.4691667 C30.1211975,19.0686111 29.9830988,18.635 29.845,18.1683333 Z",
    id: "Combined-Shape",
    fill: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "times-circle-copy-2",
    transform: "translate(36.000000, 35.000000)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C3.13306452,0 0,3.13306452 0,7 C0,10.8669355 3.13306452,14 7,14 C10.8669355,14 14,10.8669355 14,7 C14,3.13306452 10.8669355,0 7,0 Z M10.4322581,8.8375 C10.5649194,8.97016129 10.5649194,9.18467742 10.4322581,9.31733871 L9.31451613,10.4322581 C9.18185484,10.5649194 8.96733871,10.5649194 8.83467742,10.4322581 L7,8.58064516 L5.1625,10.4322581 C5.02983871,10.5649194 4.81532258,10.5649194 4.68266129,10.4322581 L3.56774194,9.31451613 C3.43508065,9.18185484 3.43508065,8.96733871 3.56774194,8.83467742 L5.41935484,7 L3.56774194,5.1625 C3.43508065,5.02983871 3.43508065,4.81532258 3.56774194,4.68266129 L4.68548387,3.56491935 C4.81814516,3.43225806 5.03266129,3.43225806 5.16532258,3.56491935 L7,5.41935484 L8.8375,3.56774194 C8.97016129,3.43508065 9.18467742,3.43508065 9.31733871,3.56774194 L10.4350806,4.68548387 C10.5677419,4.81814516 10.5677419,5.03266129 10.4350806,5.16532258 L8.58064516,7 L10.4322581,8.8375 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramDeclined);
export default __webpack_public_path__ + "static/media/program_declined.be552585cc12cf57a138a53a3cfd03cd.svg";
export { ForwardRef as ReactComponent };